export var getValue = function (name, values) {
    return name.split('.').reduce(function (result, currentKey) {
        if (typeof result === 'object')
            return result[currentKey];
        return result;
    }, values);
};
export var fieldValueIsSame = function (prevProps, nextProps) {
    return !!prevProps.name &&
        !!nextProps.name &&
        getValue(prevProps.name, prevProps.formik.values) ===
            getValue(nextProps.name, nextProps.formik.values) &&
        prevProps.formik.errors[prevProps.name] ===
            nextProps.formik.errors[nextProps.name];
};
export var localeIsSame = function (prevProps, nextProps) { return prevProps.label === nextProps.label; };
export var disabledIsSame = function (prevProps, nextProps) { return prevProps.disabled === nextProps.disabled; };
